<template>
    <div>
        <template v-if="loaded">
            <rkm-alert
                v-if="model.confirmado"
                color="success"
            >
                Transferência aceita pelo destino.
            </rkm-alert>

            <rkm-alert
                v-else-if="model.recusado"
                color="danger"
            >
                Transferência recusada pelo destino.
            </rkm-alert>

            <rkm-form :show-legend="!model.confirmado && !model.recusado">
                <rkm-area title="Dados do destino">
                    <rkm-form ref="Form">
                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="model.finalizada || hasItens"
                                    :options="form.destino.unidades"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    textField="nomeFantasia"
                                    v-model="form.destino.unidadeId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="model.finalizada || !form.destino.unidadeId || hasItens"
                                    :options="infraestruturas"
                                    :validations="validations.infraestrutura"
                                    label="Local de atendimento"
                                    show-default-option
                                    textField="nome"
                                    v-model="form.destino.infraestruturaId"
                                    valueField="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="model.finalizada || !form.destino.infraestruturaId || hasItens"
                                    :options="centrosCusto"
                                    :validations="validations.centroCusto"
                                    label="Setor"
                                    show-default-option
                                    textField="setorNome"
                                    v-model="model.destino.centroCustoId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="model.finalizada || !form.destino.infraestruturaId"
                                    :repository="repositories.usuario"
                                    :request-query-string-params="autocompleteQueryStringParams.usuario"
                                    :search-fields="autocompleteFields.usuario"
                                    :validations="validations.usuario"
                                    label="Usuário"
                                    uppercase
                                    v-model="model.destino.usuario"
                                    text-field="cidadaoNome"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>
                </rkm-area>

                <Material
                    :data="{ additionals, model }"
                    ref="Material"
                />
            </rkm-form>
        </template>
    </div>
</template>

<script>
// Components.
import Material from './components/material/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, stringCase, object, data, file } from '@/mixins'

export default {
    components: { Material },
    computed: {
        autocompleteFields() {

            return {
                usuario: [
                    { key: 'cadastro_cidadao.nome', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                usuario: {
                    infraestrutura_id: this.form.destino.infraestruturaId
                }
            }
        },
        validations() {

            return {
                unidade: {
                    required: true,
                },
                infraestrutura: {
                    required: true,
                },
                centroCusto: {
                    required: true,
                },
                usuario: {
                    required: true,
                },
            }
        },
        infraestruturas() {

            if (this.form.destino.unidadeId) {

                return this.form.destino.unidades
                    .find(u => u.id === this.form.destino.unidadeId).infraestruturas
            }

            return []
        },
        centrosCusto() {

            if (this.form.destino.infraestruturaId && this.infraestruturas.length > 0) {

                const infrasestrutura = this.infraestruturas.find(i => i.id === this.form.destino.infraestruturaId)

                return infrasestrutura ? infrasestrutura.centrosCusto : []
            }

            return []
        },
        hasItens() {

            return this.model.itens.length > 0
        }
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            transferencia: this.getConectaSusRepository('almoxarifado.transferencia'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: null,
        loaded: false,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.transferencia.edit(this.id)
                : this.repositories.transferencia.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()
                    this.$emit('model-load', this.model)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('form.destino.unidadeId', function () {

                this.form.destino.infraestruturaId = null
            })

            this.$watch('form.destino.infraestruturaId', function () {

                this.model.destino.centroCustoId = null
                this.model.destino.usuario = null
            })

            this.$watch('infraestruturas', function (infraestruturas) {

                if (infraestruturas.length === 1) {

                    this.form.destino.infraestruturaId = infraestruturas[0].id
                }
            })

            this.$watch('centrosCusto', function (centrosCusto) {

                if (centrosCusto.length === 1) {

                    this.model.destino.centroCustoId = centrosCusto[0].id
                }
            })

            this.$watch('model.destino.centroCustoId', function () {

                this.$refs.Material.resetForm()
            });
        },
        toDate(mes, ano) {
            return new Date(ano, mes - 1, 1)
        },
        finalizar() {

            let balanceteFechado = this.model.ultimoBalanceteFechado[0] ?? null
            const data = new Date(this.model.ultimoBalanceteFechado[1])
            const dataAtual = this.toDate(data.getMonth() + 1, data.getFullYear())

            if(balanceteFechado){
                    balanceteFechado = this.toDate(balanceteFechado.mes,balanceteFechado.ano)
            }

            if (dataAtual <= balanceteFechado) {
                this.showAlert(
                    'Não é possível finalizar a transferência pois o balancete do mês já foi fechado.',
                    'Atenção'
                )
                return
            }

            this.showConfirmation(
                'Após finalizar não será mais possível alterar os dados do destino. Deseja continuar?',
                async () => this.save(true)
            )
        },
        save(finalizar, imprimir = false) {

            if (finalizar) {

                this.handleSave(true, imprimir)

                return
            }

            this.showConfirmation(
                `Ao salvar a transferência sem finalizar, o estoque de cada material incluído não será reservado,
                    podendo não estar disponível ao finalizar a transferência futuramente. Deseja realmente continuar?`,
                async () => this.handleSave(false, imprimir)
            )
        },
        handleSave(finalizar, imprimir) {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.model.itens.length === 0) {

                        this.showValidationNotification('Obrigatório incluir pelo menos um material.')

                        return;
                    }

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.transferencia.update(this.id, this.prepareData(finalizar))
                        : this.repositories.transferencia.store(this.prepareData(finalizar))

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()

                            if (imprimir) {

                                this.print(data.id).then(() => this.$emit('save', data))
                            }
                            else {

                                this.$emit('save', data)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData(finalizar) {

            const data = this.clone(this.model)

            data.finalizada = finalizar

            this.createIdKeysToObject(data.destino, [
                'usuario',
            ])

            data.itens.map(item => {

                item.entradaItens = item.entradaItens.filter(i => i.quantidadeSaida > 0)

                this.createIdKeysToObject(item, [
                    'material',
                ])
            })

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        print(saidaId) {

            this.setLoading()

            return this.repositories.impressao.transferencia(saidaId)
                .then(response => {

                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [ repository, error, stringCase, object, data, file ],
    props: {
        id: { type: Number }
    },
}
</script>